// Hamburger and close btn functionality
const menuBtn = document.getElementById("menuBtn");
const mobileMenu = document.getElementById("mobileMenu");
const closeBtn = document.getElementById("closeBtn");
const menuOverlay = document.getElementById("menuOverlay");

if (menuBtn && mobileMenu && closeBtn && menuOverlay) {
    menuBtn.addEventListener("click", e => {
        mobileMenu.classList.toggle("is-active");
        menuOverlay.classList.toggle("is-active");
        document.body.classList.toggle("menu-open");
    });

    closeBtn.addEventListener("click", e=> {
        mobileMenu.classList.toggle("is-active");
        menuOverlay.classList.toggle("is-active");
        document.body.classList.toggle("menu-open");
    });

    menuOverlay.addEventListener("click", e=> {
        mobileMenu.classList.remove("is-active");
        menuOverlay.classList.remove("is-active");
        document.body.classList.remove("menu-open");
    });
}

if (mobileMenu) {
    // Find all menu items with children within the mobile menu
    const menuItemsWithChildren = mobileMenu.querySelectorAll('.menu-item-has-children');

    // Iterate over each menu item with children
    menuItemsWithChildren.forEach(menuItem => {
        // Find the submenu-after span element
        const submenuAfter = menuItem.querySelector('.submenu-after');
        if (submenuAfter) {
            // Add click event listener to the submenu-after span element
            submenuAfter.addEventListener('click', event => {
                event.preventDefault(); // Prevent the default action (e.g., following the link)
                
                // Find the sub-menu element within this menu item
                const subMenu = menuItem.querySelector('.sub-menu');

                // Toggle the 'active-mobile' class on the sub-menu
                if (subMenu) {
                    subMenu.classList.toggle('active-mobile');
                }

                // Toggle the 'active-li' class on the parent li element
                const parentLi = menuItem.closest('li');
                if (parentLi) {
                    parentLi.classList.toggle('active-li');
                }

                console.log('clicked');
            });
        }
    });
}
